import competenceConstants from '../constants';

export function openCompetenceSelectionScreen() {
    return { type: competenceConstants.OPEN_COMPETENCE_SELECTION_SCREEN };
}

export function closeCompetenceSelectionScreen() {
    return { type: competenceConstants.CLOSE_COMPETENCE_SELECTION_SCREEN };
}

export function selectPendingCompetenceList() {
    return { type: competenceConstants.SELECT_PENDING_COMPETENCE_LIST };
}

export function selectAvailableCompetenceList() {
    return { type: competenceConstants.SELECT_AVAILABLE_COMPETENCE_LIST };
}

export function chooseCompetence(competence, expiryDate) {
    return { type: competenceConstants.CHOOSE_COMPETENCE, competence, expiryDate };
}

export function openScanningPage() {
    return { type: competenceConstants.OPEN_SCANNING_PAGE };
}

export function closeScanningPage() {
    return { type: competenceConstants.CLOSE_SCANNING_PAGE };
}

export function openScheduledCompetenceDialog() {
    return { type: competenceConstants.OPEN_SCHEDULED_COMPETENCE_DIALOG };
}

export function closeScheduledCompetenceDialog() {
    return { type: competenceConstants.CLOSE_SCHEDULED_COMPETENCE_DIALOG };
}

export function openAuthChooserDialog() {
    return { type: competenceConstants.OPEN_AUTH_CHOOSER };
}

export function closeAuthChooserDialog() {
    return { type: competenceConstants.CLOSE_AUTH_CHOOSER };
}

export function openQRDialog() {
    return { type: competenceConstants.OPEN_QR_DIALOG };
}

export function openQRScannerDialog() {
    return { type: competenceConstants.OPEN_QR_SCANNER_DIALOG };
}

export function closeQRDialog() {
    return { type: competenceConstants.CLOSE_QR_DIALOG };
}

export function openManualLookupDialog() {
    return { type: competenceConstants.OPEN_MANUAL_LOOKUP_DIALOG };
}

export function closeManualLookupDialog() {
    return { type: competenceConstants.CLOSE_MANUAL_LOOKUP_DIALOG };
}

export function selectCompetenceAndStartAwarding(competence, expiryDate) {
    return { type: competenceConstants.SELECT_COMPETENCE_AND_AWARD, competence, expiryDate };
}